export default __webpack_public_path__ + "static/media/GCC_Playbook2.c7a86ecb.jpg";